export const companySuggestionsActionTypes = {
    'PAGE_INIT': 'COMPANY_SUGGESTIONS_PAGE_INIT',
    'PAGE_NEXT': 'COMPANY_SUGGESTIONS_PAGE_NEXT',
    'PAGE_PREVIOUS': 'COMPANY_SUGGESTIONS_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'COMPANY_SUGGESTIONS_PAGE_REQUEST',
    'PAGE_SUCCESS': 'COMPANY_SUGGESTIONS_PAGE_SUCCESS',
    'PAGE_ERROR': 'COMPANY_SUGGESTIONS_PAGE_ERROR',
    'TOGGLE_SELECTION': 'COMPANY_SUGGESTIONS_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'COMPANY_SUGGESTIONS_CLEAR_SELECTION',
    'TOGGLE_ALL': 'COMPANY_SUGGESTIONS_TOGGLE_ALL',
    'ADD_FILTER': 'COMPANY_SUGGESTIONS_ADD_FILTER',
    'REMOVE_FILTER': 'COMPANY_SUGGESTIONS_REMOVE_FILTER',
};
